@if (action) {
  <button
    evi-mobile-raised-button
    class="evim-snackbar-action"
    [color]="action.color"
    (click)="executeCallback()"
  >
    @if (icon.name) {
      <unis-icon
        icon-top
        [icon]="icon.name"
        [font]="icon.font"
        [isSvg]="icon.isSvg"
        [sharp]="icon.sharp"
        [size]="icon.size"
      ></unis-icon>
    }
    {{ action.text | optionalAsync }}
  </button>
}
<!-- Disgusting but need to be inline to be :empty when no text -->
